<!--
영업소회원 (센터별) > 운임설정 컴포넌트
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4><i class="material-icons">edit</i>회원사 센터비용 설정</h4>
            </div>

            <div class="uk-modal-body uk-padding-small" v-if="region">
                <table class="info-table small uk-width-1-1">
                    <colgroup>
                        <col style="width: 12rem">
                        <col>
                    </colgroup>
                    <tbody>
                    <tr>
                        <th class="uk-text-right">
                            센터
                        </th>
                        <td class="uk-text-left">
                            <img :src="region.flag16"/>
                            {{ region.name }}
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-right">
                            회원사
                        </th>
                        <td class="uk-text-left">
                            {{ user.nick }}
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-right">
                            사서함
                        </th>
                        <td class="uk-text-left">
                            {{ user.mailbox }}
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-right">
                            가격표
                        </th>
                        <td class="uk-text-center">
                            <app-input-search-select
                                v-model="inputs.shipping_cost_table_id"
                                :options="shippingCostOptions"

                                placeholder="운임 가격표를 선택하세요"
                            >
                            </app-input-search-select>
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-right">
                            VAT과금
                        </th>
                        <td class="uk-text-center">
                            <app-input-select
                                class="w-10rem"
                                v-model="inputs.vat_charge_type"
                                :options="vatOptions"
                            >
                            </app-input-select>
                        </td>
                    </tr>

                    <tr>
                        <th class="uk-text-right">
                            합배송추가비
                        </th>
                        <td class="uk-text-center">
                            <div class="uk-flex uk-flex-middle">
                                <app-input-select
                                    class="w-10rem"
                                    v-model="inputs.over_amount_set_type"
                                    :options="overAmountSetTypeOptions"
                                >
                                </app-input-select>
                                <span class="ml-5">추가비({{ region.currency }}):</span>
                                <app-input-text
                                    class="w-10rem"
                                    ref="over_amount_surcharge"
                                    v-model="inputs.over_amount_surcharge"
                                ></app-input-text>
                                <span class="ml-5">면제수량:</span>
                                <app-input-text
                                    class="w-10rem"
                                    ref="surcharge_free_amount"
                                    v-model="inputs.surcharge_free_amount"
                                ></app-input-text>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <th class="uk-text-right">
                            부피할인율
                        </th>
                        <td class="uk-text-center">
                            <div class="uk-flex uk-flex-middle">
                                <app-input-select
                                    class="w-10rem"
                                    v-model="inputs.dc_rate_set_type"
                                    :options="dcRateSetTypeOptions"
                                >
                                </app-input-select>
                                <span class="ml-5">부피할인율(%):</span>
                                <app-input-text
                                    class="w-10rem"
                                    ref="volume_dc_rate"
                                    v-model="inputs.volume_dc_rate"
                                ></app-input-text>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <th class="uk-text-right">
                            델라비용
                        </th>
                        <td class="uk-text-center">
                            <div class="uk-flex uk-flex-middle">
                                <app-input-select
                                    class="w-10rem"
                                    v-model="inputs.de_cost_set_type"
                                    :options="deCostOptions"
                                >
                                </app-input-select>
                                <span class="ml-5">델라비용({{ region.currency }}):</span>
                                <app-input-text
                                    class="w-10rem"
                                    ref="de_cost"
                                    v-model="inputs.de_cost"
                                ></app-input-text>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <th class="uk-text-right">
                            출고보류요청
                        </th>
                        <td class="uk-text-center">
                            <app-input-select
                                class="w-10rem"
                                v-model="inputs.shipout_hold_req_type"
                                :options="shipoutHoldReqTypeOptions"
                            >
                            </app-input-select>
                        </td>
                    </tr>

                    <tr>
                        <th class="uk-text-right" @click="$refs.customs_clearance_cost.inputFocus()">
                            일반통관수수료(KRW)
                        </th>
                        <td class="uk-text-center">
                            <app-input-text
                                class="w-10rem"
                                ref="customs_clearance_cost"
                                v-model="inputs.customs_clearance_cost"
                            ></app-input-text>
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-right" @click="$refs.customs_clearance_biz_cost.inputFocus()">
                            사업자통관수수료(KRW)
                        </th>
                        <td class="uk-text-center">
                            <app-input-text
                                class="w-10rem"
                                ref="customs_clearance_biz_cost"
                                v-model="inputs.customs_clearance_biz_cost"
                            ></app-input-text>
                        </td>
                    </tr>

                    <tr>
                        <th class="uk-text-right">
                            구매수수료율
                        </th>
                        <td class="uk-text-left">
                            <div class="uk-flex uk-flex-middle" style="font-size: 1rem">
                                <label class="uk-margin-small-right">
                                    <input class="uk-radio" type="radio" value="none" v-model="inputs.buy_fee_rate_set_type"> 미설정
                                </label>
                                <label class="uk-margin-small-right">
                                    <input class="uk-radio" type="radio" value="member" v-model="inputs.buy_fee_rate_set_type"> 설정
                                </label>
                                <app-input-text
                                    class="w-10rem"
                                    ref="buy_fee_rate"
                                    v-model="inputs.buy_fee_rate"
                                ></app-input-text>
                                <span class="ml-5">%</span>
                            </div>
                            <div class="uk-text-muted uk-margin-small-top" style="font-size: 1rem">
                                구매요청 물품가과금 공식에 더하는 구매수수료율입니다. 미설정이면 물품가과금을 할 수 없습니다
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    @click="submit"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import regionAble from "../common/region-able.vue";

    export default {
        mixins: [
            regionAble,
        ],
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },


        },
        data: function () {
            return {
                /**
                 * (object) 사용자정보
                 */
                user: {},
                /**
                 * (object) 영업소회원 역할정보
                 */
                userRole: {},
                /**
                 * (object) 회원사 실제 적용값
                 */
                applied: {},
                /**
                 * (array) 운임표 옵션
                 */
                shippingCostOptions: [],
                /**
                 * (array) vat 옵션
                 */
                vatOptions: [],

                /**
                 * (array) 합배송 설정방법 옵션
                 */
                overAmountSetTypeOptions: [{text: '지역설정', val: 'region'}, {text: '직접설정', val: 'member'}],

                /**
                 * (array) 부피할인율 설정방법 옵션
                 */
                dcRateSetTypeOptions: [{text: '지역설정', val: 'region'}, {text: '직접설정', val: 'member'}],

                /**
                 * (array) 델라비용 설정방법 옵션
                 */
                deCostOptions: [{text: '지역설정', val: 'region'}, {text: '직접설정', val: 'member'}],

                /**
                 * (array) 출고보류요청 옵션
                 */
                shipoutHoldReqTypeOptions: [],

                /**
                 * (object) 입력값
                 */
                inputs: {
                    customs_clearance_cost: null,
                    customs_clearance_biz_cost: null,
                    shipping_cost_table_id: null,
                    vat_charge_type: null,
                    surcharge_free_amount: null,
                    over_amount_surcharge: null,
                    over_amount_set_type: null,

                    volume_dc_rate: null,
                    dc_rate_set_type: null,

                    de_cost: null,
                    de_cost_set_type: null,

                    buy_fee_rate: null,
                    buy_fee_rate_set_type: 'none',

                    shipout_hold_req_type: null,
                },


            };
        },
        computed: {

            /**
             * 지역
             * @return object
             */
            region() {
                return this.get_region(this.userRole.region_id);
            },

        },
        methods: {
            /**
             * 입력폼 display
             */
            show() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param user_id
             * @param agent_id
             */
            form(user_id, agent_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/users/' + user_id + '/agents/' + agent_id + '/member',
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.user = response.user;
                    this.userRole = response.user_role;
                    this.applied = response.applied;
                    this.shippingCostOptions = response.shipping_cost_options;
                    this.vatOptions = response.vat_options;
                    this.shipoutHoldReqTypeOptions = response.shipout_hold_req_type_options;

                    // 입력값 초기화
                    this.inputs.customs_clearance_cost = this.userRole.customs_clearance_cost;
                    this.inputs.customs_clearance_biz_cost = this.userRole.customs_clearance_biz_cost;
                    this.inputs.shipping_cost_table_id = this.userRole.shipping_cost_table_id;
                    this.inputs.vat_charge_type = this.userRole.vat_charge_type;
                    this.inputs.surcharge_free_amount = this.userRole.surcharge_free_amount;
                    this.inputs.over_amount_surcharge = this.userRole.over_amount_surcharge;
                    this.inputs.over_amount_set_type =
                        this.userRole.surcharge_free_amount === null && this.userRole.over_amount_surcharge === null
                            ? 'region' : 'member';

                    this.inputs.volume_dc_rate =
                        this.userRole.volume_dc_rate !== null
                            ? _.round(this.userRole.volume_dc_rate * 100, 2)
                            : null;
                    this.inputs.dc_rate_set_type = this.userRole.volume_dc_rate === null ? 'region' : 'member';

                    this.inputs.de_cost = this.userRole.de_cost;
                    this.inputs.de_cost_set_type = this.userRole.de_cost === null ? 'region' : 'member';

                    // 구매수수료율 (% 단위 — 서버 applied.buy_fee_rate_pct, 미설정 = null)
                    this.inputs.buy_fee_rate = this.applied.buy_fee_rate_pct;
                    this.inputs.buy_fee_rate_set_type = this.applied.buy_fee_rate_pct === null ? 'none' : 'member';

                    this.inputs.shipout_hold_req_type = this.userRole.shipout_hold_req_type;

                    // 폼띄우기
                    this.show();
                });
            },

            /**
             * submit
             */
            submit() {
                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/users/' + this.user.id + '/agents/' + this.userRole.agent_id + '/member-cost',
                    data: _.merge({
                        '_token': this.csrfToken,
                    }, this.inputs),
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>